const einDashboard = {
  einDashboard: {
    installingSince: 'Installing Enphase Since',
    accountManager: 'Enphase Account Manager',
    installationShare: 'Share of Enphase Installations',
    nps: 'Net Promoter Score',
    viewDashboard: 'View Dashboard',
    quarterInfo: 'as of Q%{quarter},%{year} (Residential)',
    npsTooltip: `The Net Promoter Score is an index ranging from -100 to 100 that measures the willingness of customers to recommend a company's products or services to others. This score is based on the ratings given by your customers in the Enlighten Mobile App for your services and is only visible to you and Enphase. The default time period for the data is last 13 months.`,
    activity: 'Activity',
    sites: 'Solar sites',
    batteries: 'Batteries',
    acb: 'ACB',
    certifications: 'Certifications',
    community: 'Community',
    storage: 'Storage sites',
    lastInstalledLabel: 'installed in last 12 months',
    lastCommissionedLabel: 'commissioned in last 12 months',
    viewDetails: 'View Details',
    seeReviews: 'See Reviews',
    viewCommunity: 'View Community',
    certificateLabel: '%{count} out of %{totalCount} Certifications completed',
    networkLabel: {
      one: '%{count} post, last post: %{postDate}',
      other: '%{count} posts, last post: %{postDate}'
    },
    requestProductAccess: 'Request Product Access',
    inverter: 'IQ-8',
    ensemble: 'Ensemble 2.0',
    permit: 'Permit Assistance',
    sgip: 'SGIP Assistance',
    learnMore: 'Learn more',
    aboutProduct: 'about the product',
    betaReleaseDate: 'Beta Release date',
    requestEarlyAccess: 'Request Early Access',
    viewAllProduct: 'View all Products',
    signUp: 'Sign Me Up',
    betaReleaseLabel: 'for all new beta product releases',
    financing: 'Financing Support',
    digitalPlatform: 'Digital Platform',
    lpp: 'LPP',
    requestedText: 'Request Sent for Early Access',
    grantedText: 'Beta Access Granted',
    products: 'Products',
    ratingsReviews: 'Ratings & Reviews',
    reviews: 'Reviews',
    otherReviews: 'Other Reviews',
    updateDetails: 'Update Details',
    totalSavings: 'Total Savings',
    inLastYear: 'In last 12 months',
    viewBreakdown: 'View Breakdown',
    leadsReceived: 'Leads Received',
    leadsClosure: 'Leads Closure',
    leadsWon: 'Leads Won',
    creditAvailable: 'Credit Available​',
    buyMore: 'Buy More',
    messageFromCeo: 'Message from our CEO',
    communityUpdates: 'Community Updates',
    makeAppointments: 'Make appointments',
    applicableText: 'Applicable for Platinum Members only',
    view: 'View',
    downloadAll: 'Download All',
    promoteText: 'Promote your company with badges and logos​',
    asOfText: 'As of: %{date}',
    yearTotal: 'Total/year',
    redeemed: 'Redeemed',
    laborProtectionPlan: 'Labor Protection Program',
    acmPromotion: 'ACM Promotion',
    save: {
      lre_data: 'Savings from LPP',
      permit_data: 'Savings from Permit',
      financing_data: 'Savings from Financing',
      sgip_data: 'Savings from SGIP',
      warrantyExtension: 'Savings on Warranty extension'
    },
    platinumLogo: 'Platinum Logo',
    enphaseLogo: 'Enphase Logo',
    otherAssets: 'Other Assets',
    ensembleCertificate: 'Ensemble Certified',
    salesCertificate: 'Sales 1.0 Certified',
    marketingCertificate: 'Marketing 1.0 Certified',
    solarInstallCertificate: 'Solar Install Certified',
    validTill: 'Valid till: %{date}',
    noDataAvailable: 'No data available',
    notAvailable: 'Not Available',
    notApplicable: 'Not Applicable',
    title: 'EIN Dashboard',
    congratulationSignUp: 'Congrats! Now you will have early access to every new Enphase product/service',
    benefits: 'Benefits',
    installationShareTooltip:
      'This number indicates what percentage of your overall installations have been  Enphase installations',
    dataFromThirdParty: '*As per data from 3rd party source',
    reviewsNotAvailable: 'Reviews Not Available',
    enphaseExecutive: 'Enphase Executive',
    digitalAssets: 'Digital Assets',
    leads: 'Leads',
    tierSavings: 'Tier Savings',
    exclusiveUpdates: 'Exclusive Updates​',
    executiveSponsor: 'Executive Sponsor',
    merchandise: 'Merchandise',
    certifiedUsers: 'Certified Users',
    noteAllowedOnce: 'Note: The above link cannot be edited once it has been created',
    saveLink: `Save Link`,
    confirm: `Confirm`,
    copyLink: 'Copy Link',
    allowedCharactersError: 'Only letters, numbers, hyphen and underscore are allowed (max 500 characters)',
    createSystemEstimatorLink: `Create your personalized System Estimator link and share it with your customers to get leads from them. Any lead generated from this link will be shared only with you in your enlighten manager.`,
    shareSystemEstimatorLink: `Share your personalized System Estimator link with your customers to get leads from them. Any lead generated from this link will be shared only with you in your enlighten manager.`,
    systemEstimatorLink: 'System Estimator Link',
    confirmChanges: 'Confirm Changes',
    confirmSELink: 'Please confirm your System Estimator Link. This link will not be editable once saved.',
    copied: `Copied`,
    mySELink: 'My System Estimator Link',
    sdtUrlExistsError: 'This link is already in use by another installer. Please choose a different link',
    all: 'All',
    filterText: 'Filter',
    noProductAvailable: 'No Product Available'
  }
};

export default einDashboard;
